import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, QRResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof QRResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

const getQRByIdQuery = (id: string) => ["qr", id]

type Props = {
  id: string
  onSuccess?: OnSuccessFn
}

export const QRByIdQuery = ({ id, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getQRByIdQuery(id),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/integrations/qr/${id}`)
      onSuccess?.(data)
      return data.data
    },
  })
}
